import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { ConcatPipe } from '@markant-platform/shared/util-pipes';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';

@Component({
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoModule, ConcatPipe, ModalBridgeComponent],
  selector: 'markant-platform-widget-context-menu',
  templateUrl: './widget-context-menu.component.html',
  styleUrls: ['./widget-context-menu.component.scss'],
})
export class WidgetContextMenuComponent {
  @Input({ required: true }) widgetId!: string;
  @Input() cartridgeId?: string;
  showPopover = false;

  @Output() widgetRemoved: EventEmitter<void> = new EventEmitter<void>();

  togglePopover(event: Event): void {
    this.showPopover = !this.showPopover;
    event.stopPropagation();
  }

  closePopover(): void {
    this.showPopover = false;
  }

  removeWidget(): void {
    this.closePopover();
    this.widgetRemoved.emit();
  }
}
